<template>
  <van-dialog v-model="show" title="请先认证身份信息" @confirm="handleConfirmPreview">
    <van-field v-model="idCard" input-align="center" placeholder="请输入身份证号" maxlength="18" size="large"/>
  </van-dialog>
</template>

<style>
</style>

<script>
import mixinLoad from '@/mixin/mixin-load.js'

import {
  bindPersonnelPreview,
  bindPersonnel
} from '@/api/user.js'
import {Dialog} from "vant";
import nativeApi from "@/utils/native-bridge";

export default {
  name: 'BindPersonnel',
  components: {},
  mixins: [mixinLoad],
  data() {
    return {
      show: false,
      idCard: undefined
    }
  },
  computed: {},
  methods: {
    showBind() {
      this.show = true
    },
    handleConfirmPreview() {
      const loading = this.showLoading();
      bindPersonnelPreview({
        idCard: this.idCard
      }).then(({
                 data
               }) => {
        loading.clear();
        this.showBindPreview(data);
      }).catch((rep) => {
        loading.clear();
        this.show = true;
        this.showErrorTip(rep.msg || rep)
      })
    },
    showBindPreview(data) {
      const name = data.name || '未录入';
      const companyName = data.companyName || '未录入';
      this.$dialog.confirm({
        title: '请确认认证信息',
        messageAlign: 'left',
        message: `姓名：${name}\n单位：${companyName}`,
        confirmButtonText: '确定认证',
        cancelButtonText: '返回',
      }).then(() => {
        this.handleConfirmBind();
      }).catch(() => {
        this.show = true;
      });
    },
    handleConfirmBind() {
      const loading = this.showLoading();
      bindPersonnel({
        idCard: this.idCard
      }).then(() => {
        loading.clear();
        this.show = false;
        Dialog.alert({title: rep.msg || '绑定成功'}).then(() => {
          nativeApi.closePage();
        })
        this.$emit('success')
      }).catch((rep) => {
        loading.clear();
        this.show = true;
        this.showErrorTip(rep.msg || rep)
      })
    }
  }
}
</script>
